module.exports = __webpack_public_path__ + "img/down-arrow-icon.a39eefc8.svg";